/**
 * operationVersionNoticeRule.js — story 184 (named *Rule because `OperationVersionNotice.jsx` lives next to it and a case-only difference collides on Windows) (CU4 · CA7, CA8 · RN-05.1, RN-05.2, RN-05.3, RN-05.6). Pure.
 *
 * The OPERATIONS view warns when the version loaded into the accordions is not the current one of its code.
 * "Current" is the HIGHEST version number of the code, whatever its Index Value (#130 `LibraryOperation.currentVersion`)
 * — not the version the panel offers for dragging (the highest APPROVED, #152). The notice is a help, never a
 * condition: when the current one cannot be known there is no notice and no error (D2).
 */

const isInteger = (value) => Number.isInteger(value)

/**
 * The current version number of a code out of its N2 detail (`OperationLibraryDetail.versions[]`): the highest
 * `versionNumber`, or `null` when the list is empty, missing or carries no integer numbers (unknown current).
 */
export const currentVersionNumberOf = (detail) => {
  const versions = Array.isArray(detail?.versions) ? detail.versions : []
  const numbers = versions.map((version) => version?.versionNumber).filter(isInteger)
  return numbers.length === 0 ? null : Math.max(...numbers)
}

/**
 * `null` (no notice) or `{ version, current }` to interpolate into
 * "Version {{version}} is not the current one: the current version is {{current}}".
 * Notice ⇔ a version is loaded (`nodeId` not empty), it is not a new unsaved operation, the current one is a
 * known integer, and the loaded number is lower than it.
 */
export const notCurrentVersionNotice = (loaded, currentVersionNumber) => {
  if (!loaded || !loaded.nodeId || loaded.isNew) return null
  if (!isInteger(currentVersionNumber) || !isInteger(loaded.versionNumber)) return null
  if (loaded.versionNumber >= currentVersionNumber) return null
  return { version: loaded.versionNumber, current: currentVersionNumber }
}
